import React, { useEffect, useRef, useState } from 'react';
import useScrollLock from '../utils/useScrollLock';
import { registerAndroidBackHandler } from '../utils/androidBack';
import {
  RIDER_NOTE_CHIPS, RIDER_NOTE_MAX_TEXT, buildRiderNote, noteHasPhone,
} from '../utils/riderNote';

/**
 * "Note for Anna" sheet on the confirm screen: quick notes plus free text.
 * onSave gets the cleaned note, or null when the rider cleared it.
 */
export default function RiderNoteSheet({ t, note, onSave, onClose }) {
  const [chips, setChips] = useState(note?.chips || []);
  const [text, setText] = useState(note?.text || '');
  useScrollLock();
  // The phone's Back closes this sheet first, instead of moving the booking screen under it.
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;
  useEffect(() => registerAndroidBackHandler(() => { onCloseRef.current(); return true; }), []);

  const hasPhone = noteHasPhone(text);
  const toggle = (code) => setChips((cur) => (cur.includes(code) ? cur.filter((c) => c !== code) : [...cur, code]));

  return (
    <div className="modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className="modal-sheet rider-note-sheet"
        role="dialog"
        aria-modal="true"
        aria-label={t('riderNote.title')}
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="rider-note-title">{t('riderNote.title')}</h3>
        <p className="rider-note-sub">{t('riderNote.sub')}</p>
        <div className="rider-note-chips">
          {RIDER_NOTE_CHIPS.map((code) => {
            const on = chips.includes(code);
            return (
              <button
                key={code}
                type="button"
                className={`rider-note-chip${on ? ' on' : ''}`}
                aria-pressed={on}
                onClick={() => toggle(code)}
              >
                {on ? '✓ ' : ''}{t(`riderNote.chip_${code}`)}
              </button>
            );
          })}
        </div>
        <div className="cancel-flow-note">
          <textarea
            rows={3}
            value={text}
            maxLength={RIDER_NOTE_MAX_TEXT}
            placeholder={t('riderNote.placeholder')}
            aria-label={t('riderNote.title')}
            onChange={(e) => setText(e.target.value)}
          />
          <span className="cancel-flow-note-foot">
            <span className={hasPhone ? 'rider-note-warn' : ''} role={hasPhone ? 'alert' : undefined}>
              {hasPhone ? t('riderNote.noPhone') : ''}
            </span>
            <span>{text.length}/{RIDER_NOTE_MAX_TEXT}</span>
          </span>
        </div>
        <p className="rider-note-privacy">🔒 {t('riderNote.privacy')}</p>
        <button
          type="button"
          className="rapido-book-btn"
          disabled={hasPhone}
          onClick={() => onSave(buildRiderNote(chips, text))}
        >
          {t('riderNote.save')}
        </button>
        {note && (
          <button type="button" className="btn btn-ghost rider-note-remove" onClick={() => onSave(null)}>
            {t('riderNote.remove')}
          </button>
        )}
      </div>
    </div>
  );
}
